import { Component, OnDestroy, OnInit } from '@angular/core';
import { WindowReferenceService, ICustomWindow, LoadingService } from '@core/shared';
import { PreloginService } from '@core/prelogin/services/prelogin.service';
import { forkJoin, Subscription } from 'rxjs';
import { browserRefresh } from '@app/app.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Router, RouterEvent } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { HttpImageService } from '@core/shared/services/http-img.service';
import { uniqueFieldValidation, userAddress } from '../../../../extension/Models/userAddresDetailModel';


let windowObject = window as any;

@Component({
    selector: 'app-account-register',
    templateUrl: './account-register.component.html',
    styleUrls: ['./account-register.component.scss']
})
export class AccountRegisterComponent implements OnInit, OnDestroy {
    private _window: ICustomWindow;
    lstcomments: any;
    contentPageId: string;
    contentPageDetails: any;
    showLoginPageLink: boolean = false;
    selectedCulture: string;
    languageChangeSubscription: Subscription;
    navigationStartSubscription: Subscription;
    browserRefresh: boolean;
    constructor(public preloginService: PreloginService, public windowRef: WindowReferenceService,
        private translateService: TranslateService,
        private router: Router, public loadingService: LoadingService,
        private imgService: HttpImageService) {
        this._window = windowRef.nativeWindow;
    }

    ngOnInit(): void {
        windowObject.parent.preloginService = this.preloginService;
        windowObject.parent.translate = this.translateService;
        windowObject.parent.preRegistrationCallBack = function (userDetails): Promise<any> {
            let addressObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Address");
            let jobRolebject: any = Object.values(userDetails).find(x => x["fieldName"] == "Job Role");
            let emailObject: any = Object.values(userDetails).find(x => x["fieldName"] == "EmailAddress");
            let mobileObject: any = Object.values(userDetails).find(x => x["fieldName"] == "MobileNumber");
            let userObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Username");
            let organisationObject: any = Object.values(userDetails).find(x => x["fieldName"] == "OrganisationName");
            let alternateMobileObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Alternative Mobile Number");
            let panObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Pan");
            const promise = new Promise(async (resolve, reject) => {
                var random = Math.floor(Math.random() * Math.floor(100000000));
                var response = {
                    "success": true,
                    "errorCode": "",
                    "responseMessage": "",
                    "customAttributes": {

                    }
                };
                if (userObject ?.fieldValue != mobileObject ?.fieldValue.phoneNumber) {
                    //debugger;
                    var response = {
                        "success": false,
                        "errorCode": "",
                        "responseMessage": "Mobile number & confirm mobile number are not matching",
                        "customAttributes": {
                        }
                    };
                    reject(response);
                }

                if(addressObject && addressObject.value.postalCode)
                {
                    const PINCODE_REGEX = /^[1-9][0-9]{5}$/;
                    if (!PINCODE_REGEX.test(addressObject.value.postalCode)) {
                        //debugger;
                        var response = {
                            "success": false,
                            "errorCode": "",
                            "responseMessage": "Please enter the correct PIN code (6 Digits numbers only)",
                            "customAttributes": {
                            }
                        };
                        reject(response);
                    }
                }

                let isError = false; let errorMsg = '';

                if (!isError && addressObject) {
                    //debugger;
                    let model = new userAddress();
                    model.city = addressObject.value.city;
                    model.state = addressObject.value.state;
                    const emptyGuid: string = '00000000-0000-0000-0000-000000000000';

                    let uniqueValidate = new uniqueFieldValidation();
                    uniqueValidate.mobileNumber = mobileObject ?.fieldValue.phoneNumber;
                    uniqueValidate.userName = userObject ?.fieldValue;
                    uniqueValidate.additionalMobileNumber = alternateMobileObject ?.fieldValue;
                    uniqueValidate.creationMode = "Register";
                    uniqueValidate.emailId = emailObject?.fieldValue;
                    uniqueValidate.panNumber = panObject?.fieldValue;
                    //debugger;
                    forkJoin({
                        hierarchy: windowObject.parent.preloginService.getRelaxoHierarchyGroupDetails(model.city),
                        uniqueCheck: windowObject.parent.preloginService.checkUniqueDataValidation(uniqueValidate)
                    }).
                        subscribe(({ hierarchy, uniqueCheck }) => {
                            //debugger;
                            let hierarchyResponse: any = hierarchy;
                            if (isError) {
                                response.success = false;
                                response.responseMessage = errorMsg;
                                reject(response);
                            }
                            else if (hierarchyResponse.hierarchyIds == emptyGuid) {
                                //debugger;
                                response.success = false;
                                response.responseMessage = "Hierarchy Does Not Exist";
                                reject(response);
                            }
                            else {
                                //debugger;
                                response.customAttributes = {
                                    "CreateOrganisation": "{\"Name\":\"" + organisationObject ?.fieldValue + "\",\"OrganisationCode\":\"" + userObject ?.fieldValue + "\",\"Online\":true,\"HierarchyGroupId\":\"" + hierarchyResponse.hierarchyIds + "\",\"Address1\":\"" + addressObject.value.line1 + "\",\"Address2\":\"" + addressObject.value.line2 + "\",\"Address3\":\"" + addressObject + "\",\"Town\":\"" + addressObject.value.city + "\",\"County\":\"" + addressObject.value.state + "\",\"PostCode\":\"451231\",\"CountryIsoCode\":\"IND\",\"Phone\":\"1543215432\",\"Email\":\"" + userObject ?.fieldValue + "_dummy@biw.com\",\"Attributes\":[{\"Name\":\"Attr1\",\"ValueAsString\":\"ValueAsString1\",\"DataType\":\"Text\",\"SortOrder\":\"1\"},{\"Name\":\"Attr2\",\"ValueAsString\":\"ValueAsString2\",\"DataType\":\"Text\",\"SortOrder\":\"2\"}],\"HierarchyGroupIds\":[\"" + hierarchyResponse.hierarchyIds + "\"]}",
                                    "Account Status": "Online",
                                    "UserStatus": null,
                                    "CreationSource": localStorage.getItem('CreationSource') ? localStorage.getItem('CreationSource') : "BIW-Web",
                                    "UpdationSource": null,
                                    "ErrorMessage": null,
                                    "IsUserPushedToSfdc": "False",
                                    "Latitude": localStorage.getItem('Latitude') ? localStorage.getItem('Latitude') : "",
                                    "Longitude": localStorage.getItem('Longitude') ? localStorage.getItem('Longitude') : "",
                                    "Approval Status": "Not Submitted"
                                };
                                response.responseMessage = JSON.stringify(userDetails)
                                resolve(response);
                            }
                        },
                            (err) => {

                                response.success = false;
                                if (err.error && err.error.modelState) {
                                    Object.keys(err.error.modelState).forEach(key => {
                                        let errorKey = key.charAt(0).toUpperCase() + key.slice(1)
                                        response.responseMessage = windowObject.parent.translate.instant(errorKey);
                                    });
                                } else {
                                    response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.RequiredFieldValidation");
                                }
                                reject(response);
                            });
                }
                else if (isError) {
                    response.success = false;
                    response.responseMessage = errorMsg;
                    reject(response);
                }
                else {
                    //response.responseMessage = JSON.stringify(userDetails)
                    resolve(response);
                }


            });
            return promise;

        };

        windowObject.parent.addressCallback = async (val, data) => {

            let details = {
                "localeCode": this.selectedCulture,
                "code": data
            };
            switch (val) {
                case "COUNTRY":
                    let countryPromise = await this.preloginService.getCountries(details);
                    return countryPromise.country;
                case "STATE":
                    let statesPromise = await this.preloginService.getStates(details);
                    return statesPromise.state;
                case "CITY":
                    let cityPromise = await this.preloginService.getCities(details);
                    return cityPromise.city;
                default:
                    return Promise.reject();
            }
        }

        windowObject.parent.postRegistrationCallBack = (userDetails, message) => {
            this.showLoginPageLink = true;
        };

        this.navigationStartSubscription = this.router.events.pipe(
            filter((event) => event instanceof RouterEvent),
            startWith('Initial call')
        ).subscribe((res) => {
            this.browserRefresh = browserRefresh;
            this.getConfig();
        });

        this.languageChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            if (!this.browserRefresh) {
                window.location.reload();
                this.getContentPage(this.contentPageId);
            }
            else
                this.browserRefresh = false;
        });
    }

    getContentPage(contentPageId) {
        this.selectedCulture = localStorage.getItem('culture');
        this.loadingService.doLoading(this.preloginService.getRegisterContentPage(contentPageId, this.selectedCulture), this)
            .subscribe(response => {
                this.contentPageDetails = this.imgService.parseHtml(response);
                setTimeout(() => {
                    this.fetchBlobImages();
                });
            });
    }

    fetchBlobImages() {
        let images = document.querySelectorAll('img[data-src]');
        for (let image of Array.from(images)) {
            let dataSrc = image.getAttribute('data-src');
            this.imgService.getImage(dataSrc).subscribe(val => {
                let type = val.type;
                let reader = new FileReader();
                reader.readAsDataURL(val);
                reader.onloadend = function () {
                    let baseImage = <string>reader.result;
                    image.setAttribute('src', `data:${type};base64,` + baseImage.split(',')[1]);
                }
            });
        }
    }

    getConfig() {
        this.selectedCulture = localStorage.getItem('culture');
        this.preloginService.selfRegistrationConfig().subscribe(data => {
            this.renderForm(data);
            this.contentPageId = data.contentUserRegisterFormId;
            this.getContentPage(this.contentPageId);
        })
    }

    renderForm(configs) {
        this.preloginService.selfRegistration(configs, this.selectedCulture).subscribe(data => {
            this._window.__selfRegistrationAppData__ = data;
            this._window.loadSelfRegistrationInDom('selfRegistrationRoot');
        });
    }

    ngOnDestroy() {
        if (this.languageChangeSubscription)
            this.languageChangeSubscription.unsubscribe();
        if (this.navigationStartSubscription)
            this.navigationStartSubscription.unsubscribe();
    }

    isShownDivMaterial: boolean = false; // hidden by default
    toggleShowsMaterial() {
        this.isShownDivMaterial = !this.isShownDivMaterial;
    }
}
